export type FileAttributeValue = {
  /**
   * `id` is a ref identifier in file storage\
   * value after "base64" is a file name
   *
   * @example
   *  [
   *    "data:id=53eefeab-b0a4-40de-83d5-7eb063c909d2;base64,qweasdzxc",
   *    "data:id=6bbf79d2-6e84-49cc-9473-3bc3c3dfbcc1;base64,iuytrew"
   *  ]
   */
  fileRefs: string[];
};

/**
 * taken from https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem \
 * original examples from mdn:
 *    new TextDecoder().decode(__base64ToBytes("YSDEgCDwkICAIOaWhyDwn6aE")); // "a Ā 𐀀 文 🦄"
 */
function __base64ToBytes(base64: string): Uint8Array {
  const binString = atob(base64);
  return Uint8Array.from(binString, (m) => m.codePointAt(0) || 0);
}

// @ts-ignore
const decodeFromBase64 = (base64Str: string) => new TextDecoder().decode(__base64ToBytes(base64Str));

export const getNameFromFileAttributeRef = (ref: FileAttributeValue["fileRefs"][0]) => {
  const base64Indx = ref.indexOf("base64,");
  const nameBase64 = ref.slice(base64Indx + 7).trim();

  return decodeFromBase64(nameBase64);
};